import { Navigate, Outlet, RouteObject } from 'react-router'
import { AccountRoles } from './account-roles'
import { AccountRolesCreate } from './account-roles-create'
import { AccountRolesEdit } from './account-roles-edit'
import { MyIdentities } from './my-identities'
import { MySettings } from './my-settings'
import { ObjectLayouts } from './object-layouts'
import { ObjectLayoutsCreate } from './object-layouts-create'
import { ObjectLayoutsEdit } from './object-layouts-edit'
import { ObjectProperties } from './object-properties'
import { ObjectPropertiesCreate } from './object-properties-create'
import { ObjectPropertiesEdit } from './object-properties-edit'
import { ReservationDocumentCreate } from './reservation-document-create'
import { ReservationDocumentEdit } from './reservation-document-edit'
import { ReservationDocumentInspect } from './reservation-document-inspect'
import { ReservationDocuments } from './reservation-documents'
import { Root } from './root'
import { Users } from './users'
import { UsersEdit } from './users-edit'
import { UsersInvite } from './users-invite'

export const SETTINGS_ROUTES: RouteObject = {
	path: '*',
	element: <Root />,
	children: [
		{
			path: 'me',
			element: <Outlet />,
			children: [
				{
					path: '',
					index: true,
					element: <MySettings />,
				},
				{
					path: 'identities',
					element: <MyIdentities />,
				},
			],
		},
		{
			path: 'users',
			element: <Outlet />,
			children: [
				{
					path: '',
					index: true,
					element: <Users />,
				},
				{
					path: 'invite',
					element: <UsersInvite />,
				},
				{
					path: ':id',
					element: <UsersEdit />,
				},
			],
		},
		{
			path: 'roles',
			element: <Outlet />,
			children: [
				{
					path: '',
					index: true,
					element: <AccountRoles />,
				},
				{
					path: 'create',
					element: <AccountRolesCreate />,
				},
				{
					path: ':id',
					element: <AccountRolesEdit />,
				},
			],
		},
		{
			path: 'reservation',
			element: <Outlet />,
			children: [
				{
					path: '',
					element: <Navigate to="properties" replace />,
				},
				{
					path: 'properties',
					children: [
						{
							path: '',
							index: true,
							element: <ObjectProperties kind="reservation" />,
						},
						{
							path: 'create',
							element: <ObjectPropertiesCreate kind="reservation" />,
						},
						{
							path: ':id',
							element: <ObjectPropertiesEdit kind="reservation" />,
						},
					],
				},
				{
					path: 'layouts',
					children: [
						{
							path: '',
							index: true,
							element: <ObjectLayouts kind="reservation" />,
						},
						{
							path: 'create',
							element: <ObjectLayoutsCreate kind="reservation" />,
						},
						{
							path: 'edit/:id',
							element: <ObjectLayoutsEdit kind="reservation" />,
						},
					],
				},
				{
					path: 'documents',
					children: [
						{
							path: '',
							index: true,
							element: <ReservationDocuments />,
						},
						{
							path: 'create',
							element: <ReservationDocumentCreate />,
						},
						{
							path: ':id',
							element: <ReservationDocumentEdit />,
						},
						{
							path: 'inspect/:id',
							element: <ReservationDocumentInspect />,
						},
					],
				},
			],
		},
		{
			path: ':object',
			element: <Outlet />,
			children: [
				{
					path: '',
					element: <Navigate to="properties" replace />,
				},
				{
					path: 'properties',
					element: <Outlet />,
					children: [
						{
							path: '',
							index: true,
							element: <ObjectProperties />,
						},
						{
							path: 'create',
							element: <ObjectPropertiesCreate />,
						},
						{
							path: ':id',
							element: <ObjectPropertiesEdit />,
						},
					],
				},
				{
					path: 'layouts',
					element: <Outlet />,
					children: [
						{
							path: '',
							index: true,
							element: <ObjectLayouts />,
						},
						{
							path: 'create',
							element: <ObjectLayoutsCreate />,
						},
						{
							path: 'edit/:id',
							element: <ObjectLayoutsEdit />,
						},
					],
				},
			],
		},
	],
}
